// Item 745 — the Financial summary card's Supply cost row.
//
// ⛔ `supply_cost_pct` is a budget someone typed in at account setup, never a
// measurement — nothing records a supply purchase against the building it
// went to, so there is no purchase-by-building figure behind this number. The
// row must never say "calculated" and must never read the stored fraction
// (0.0350) as a percentage without multiplying by 100 (it rendered "0.04%").
//
// Pure, so a node test can read it without the Supabase client.
export function supplyCostElsewhereRow(pct: number | null): { value: string; note: string } {
  // toFixed(2) then back through Number() drops both the trailing zero
  // (3.50 → 3.5) and the floating-point noise 0.035 * 100 produces on its own.
  const percent = pct == null ? null : Number((pct * 100).toFixed(2));
  return {
    value: percent == null ? '(not set)' : `${percent}% of revenue — budget`,
    note: "The supply budget set for this building. It isn't measured from purchases.",
  };
}
